import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  OnInit,
  ElementRef,
  ChangeDetectorRef,
  Inject,
} from "@angular/core";

import { isSameMonth } from "date-fns";

import { interval, Observable, of, Subject } from "rxjs";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  CalendarEvent,
  CalendarView,
  CalendarMonthViewBeforeRenderEvent,
  CalendarDateFormatter,
  CalendarWeekViewBeforeRenderEvent,
} from "angular-calendar";

import * as moment from "moment";

import { CustomDateFormatter } from "./custom-date-formatter.provider";
import { GlobalVariable } from "../app.component";
import { DataService } from "../dataService/data.service";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute } from "@angular/router";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { CommonService } from "../services/common.service";
import { mergeMap } from "rxjs/operators";
import { NgForm } from "@angular/forms";

@Component({
  selector: "app-customer-appointment-booking",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./customer-appointment-booking.component.html",
  styleUrls: [
    "../review-experience/review-experience.component.scss",
    "../review-experience-layout/review-experience-layout.component.scss",
    "./customer-appointment-booking.component.scss",
  ],
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter,
    },
  ],
})
export class CustomerAppointmentBookingComponent implements OnInit {
  @ViewChild("addAppointment", { static: true }) addAppointment: ElementRef;
  @ViewChild("noSlotsAvailable", { static: true }) noSlotsAvailable: ElementRef;
  @ViewChild("creditsExhaustedModal", { static: true })
  creditsExhaustedModal: ElementRef;
  BASE_URL = GlobalVariable;
  view: CalendarView = CalendarView.Month;

  CalendarView = CalendarView;

  viewDate: any = this.commonService.onDateFilter();
  selectedDate: string = moment(this.commonService.onDateFilter()).format(
    "DD-MM-YYYY"
  );
  startAt: any = this.commonService.onDateFilter();
  refresh: Subject<any> = new Subject();
  slug: string;
  slotsAvailable;
  businessName: string;
  businessLogo: string;
  slotSelected: string;
  addAppSubmitClicked: boolean = false;
  lastBookingDate: string;
  showPageNotFound: boolean = false;
  loading: boolean = false;
  noSlotsAvailablePopupDate: string;
  whatsAppConnected: string;
  "false";
  optionForWhatsApp: boolean = false;
  isCategeryEnabled: boolean;
  categoryList: [];
  CategorySelected: string = "";
  creditsExhausted: boolean = false;
  ownerNumber: string;
  teamMemberSelected: string = "";
  is_template_approved: any;
  isFlexFieldEnabled: any;
  isAppointmentFlexFieldEnabled: any;
  addAppointmentFlexFieldList: any = [];
  source: string = "";
  managerList: any;
  tag_team_member: any;
  tag_team_member_setting: any;
  isSubmitClicked: boolean = false;
  disabled_till_response: boolean = false;
  public_holiday: any;
  showMeetingLink: any;
  enableMeetingLink: boolean = false;
  google: any;
  selected_tab_circle: any = "step_1";
  teamMemberSelectedName: any;
  tagTeamMemberDisplayName: any;
  stepOneSubmitClicked: boolean;
  showSuccessScreen: boolean = false;
  appointment_id: string;
  notes: any;
  phone_number: any;
  category_name: any;
  slot_time: string;
  name: any;
  id: any;
  date: string;
  is_product_blocked: any;
  appointment_id_show: any;
  appointment_cust_name = "";
  appointment_phone_number = "";
  appointment_notes = "";
  timeZone = this.getClock();
  currentDate = this.commonService.onDateFormat(new Date(), "DD-MM-YYYY");
  autoAssignTeamMember: boolean;
  emailID: string;
  notificationChannel: "SMS" | "EMAIL";
  businessOutletName: any;

  constructor(
    private modal: NgbModal,
    private httpService: DataService,
    private toastrService: ToastrService,
    private ref: ChangeDetectorRef,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private commonService: CommonService,
    private route: ActivatedRoute
  ) {
    // setInterval(() => {
    //   this.timeZone = this.commonService.getDate();
    //   this.ref.detectChanges();
    // }, 1000);
    this.route.params.subscribe((data) => {
      this.slug = data.slug;
    });
  }
  getClock(): Observable<Date> {
    return interval(1000).pipe(
      mergeMap(() => of(this.commonService.getDate()))
    );
  }
  setCurrentDateACloseModel(){
    this.viewDate = this.commonService.onDateFilter();
    this.showSuccessScreen = false;
  }

  ngOnInit() {
    this.getInitialData();

    let referrer = document.referrer;
    this.source = "";
    const checkLocalStorageSource = sessionStorage.getItem("source");
    console.log(checkLocalStorageSource, "check null");
    if (checkLocalStorageSource == null) {
      if (referrer.includes("facebook")) {
        this.source = "Facebook";
        sessionStorage.setItem("source", JSON.stringify(this.source));
        console.log(checkLocalStorageSource);
      } else if (referrer.includes("google")) {
        this.source = "Google";
        sessionStorage.setItem("source", JSON.stringify(this.source));
      } else {
        this.source = "Others";
        sessionStorage.setItem("source", JSON.stringify(this.source));
      }
    }
    // setTimeout(() => {
    //   this.modal.open(this.addAppointment, { size: 'lg' });
    // })
    // let regex = "((http|https)://)?(www[.])?facebook.com/.*";
    // let ismatch = x.match(regex);
    // console.log(ismatch);
  }
  onSlotChange(slot) {
    // console.log("slot", slot);
    this.slotSelected = slot;
    this.getTeamMembers();
  }
  getInitialData() {
    this.loading = true;
    this.httpService
      .putRequest({
        customApiUrl: this.BASE_URL.APPOINTMENT_SLUG,
        data: { slug: this.slug },
      })
      .subscribe(
        (data: any) => {
          if (data.code === 200) {
            // console.log("settings", data.data);
            this.loading = false;
            this.storage.set("offset", data.data.offset);
            this.businessName = data.data.business_name;
            this.businessOutletName = data.data.business_outlet_name;
            this.businessLogo = data.data.business_logo;
            this.ownerNumber = data.data.owner_number;
            this.lastBookingDate =
              data.data.appointment_setting_details.last_booking_date;
            this.whatsAppConnected = data.data.whatsapp_account.Whatsapp_status;
            this.is_template_approved = data.data.is_template_approved;
            this.isCategeryEnabled =
              data.data.appointment_setting_details.enable_appointment_category;
            this.tagTeamMemberDisplayName =
              data.data.appointment_setting_details.display_name;
            this.categoryList = data.data.categories;
            this.categoryList = data.data["categories"].filter((e) => {
              return e.category_name != "";
            });
            this.isAppointmentFlexFieldEnabled =
              data.data.appointment_setting_details.enable_appointment_flex_field;
            this.tag_team_member =
              data.data.appointment_setting_details.tag_team_member;

            this.tag_team_member_setting =
              data.data.appointment_setting_details.tag_team_member_setting;
            this.autoAssignTeamMember =
              data.data.appointment_setting_details.auto_assign_team_member;
            this.notificationChannel =
              data.data.appointment_setting_details.notification_channel;

            this.public_holiday = data.data.public_holiday;
            this.is_product_blocked = data.data.is_product_blocked;
            this.showMeetingLink =
              data.data.appointment_setting_details["enable_meeting_link"];
            this.google = data.data.google;

            const addAppointmentFlexFieldList = data.data["field_details"];
            ((flexFields) => {
              flexFields.forEach((field) => {
                this.addAppointmentFlexFieldList.push({
                  name: field.field_name == null ? "" : field.field_name,
                  field_id: field.field_id,
                  input_type: field.input_type,
                  required: field.required,
                  content: field.input_type === "Toggle" ? false : "",
                });
              });
            })(addAppointmentFlexFieldList);

            this.addAppointmentFlexFieldList =
              this.addAppointmentFlexFieldList.filter((e) => {
                return e.name != "";
              });
            // let appointmentLimit = data.data.appointment_limit;
            // let appointmentUsage = data.data.appointment_usage;
            // if (appointmentLimit) {
            //   let creditsUsed = (Number(appointmentUsage) / Number(appointmentLimit) * 100);
            //   if (creditsUsed >= 100) {
            //     this.creditsExhausted = true;
            //   }
            // }

            let appointmentLimit = data.data.appointment_limit;
            let appointmentUsage = data.data.appointment_usage;
            let outletStatus = data.data["outlet_status"];
            let subscriptionEndDate = data.data.subscription_end_date;
            // let business_name = data.data.business_name;

            if (outletStatus == "Active") {
              if (appointmentLimit) {
                let creditsUsed =
                  (Number(appointmentUsage) / Number(appointmentLimit)) * 100;
                if (creditsUsed >= 90 && creditsUsed < 100) {
                  let creditsLeft = appointmentLimit - appointmentUsage;
                  // this.warningText = `You have only ${creditsLeft} appointments available till you exhaust your account. Please upgrade to enjoy uninterrupted services - Call ${support_phone} or email support@zceppa.com to upgrade`;
                }
                if (creditsUsed >= 100) {
                  this.creditsExhausted = true;
                  // this.warningText = `Ooops it looks like your account needs an upgrade to continue using Zceppa. Call ${support_phone} or email support@zceppa.com to upgrade`;
                }
                if (
                  moment(new Date()).isAfter(
                    moment(subscriptionEndDate, "YYYY-MM-DD"),
                    "date"
                  )
                ) {
                  // this.creditsExhausted = true;
                  // this.warningText = `Ooops it looks like your account needs an upgrade to continue using Zceppa. Call ${support_phone} or email support@zceppa.com to upgrade`;
                }
              }
            } else if (outletStatus == "Trial") {
              if (
                moment(new Date()).isAfter(
                  moment(subscriptionEndDate, "YYYY-MM-DD"),
                  "date"
                )
              ) {
                this.creditsExhausted = true; // disabled create oredrs button
                // this.warningText = `Hi, looks like your trial has already expired. Please reach out to us to activate your Zceppa account at support@zceppa.com or Call ${support_phone}`;
              }
            }

            this.refresh.next();
          }
        },
        (error) => {
          this.loading = false;
          // this.showPageNotFound = true;
          this.refresh.next();
          console.log("error", error);
        }
      );
  }

  ngOnDestroy() {
    this.storage.remove("offset");
  }

  getAppointmentDetail() {
    this.loading = true;
    this.httpService
      .getRequest({
        customApiUrl:
          this.BASE_URL.GET_DELETE_APPOINTMENT_SLUG + "/" + this.appointment_id,
      })
      .subscribe(
        (data: any) => {
          this.loading = false;
          this.ownerNumber = data.data.owner_number;
          this.phone_number = data.data.appointments[0].phone_number;
          this.notes = data.data.appointments[0].notes;
          this.slot_time = moment(data.data.appointments[0].slot_time, [
            "hh:mm A",
          ]).format("hh:mm A");
          this.category_name = data.data.appointments[0].category_name;
          this.name = data.data.appointments[0].name;
          this.id = data.data.appointments[0].id;
          this.businessLogo = data.data.business_logo;
          this.businessName = data.data.business_name;
          this.businessOutletName = data.data.business_outlet_name;
          this.appointment_id_show = data.data.appointments[0].appointment_id;
          this.date = moment(
            data.data.appointments[0].date,
            "YYYY-MM-DD"
          ).format("DD-MM-YYYY");
          console.log(this.date);
          this.ref.markForCheck();
          if (data.code === 200) {
            // this.date = moment("2020-6-21", 'YYYY-MM-DD').format('DD-MM-YYYY');
            // const appointmentFlexFields = data.data.appointments[0].appointment_flex_details;
            // ((flexFields) => {
            //   if (flexFields.length !== 0) {
            //     flexFields.forEach(field => {
            //       this.appointmentFlexFields.push({
            //         name: field.name == null ? '' : field.name,
            //         content: field.content == null ? '' : field.content
            //       });
            //     });
            //   } else {
            //     this.appointmentFlexFields = [];
            //   }
            // })(appointmentFlexFields);
            // console.log("hideDeleteBtn", this.hideDeleteBtn);
          }
          console.log("date", this.date);
          console.log(moment(new Date()));
        },
        (error) => {}
      );
  }

  isFlexInvalid(flexField) {
    const isInvalid = flexField.some((field) => {
      if (
        this.isAppointmentFlexFieldEnabled &&
        field.required &&
        (field.content == "" || field.content == null) &&
        field.input_type !== "Toggle"
        || (field.input_type == "Number" && this.isNan(field.content))
      ) {
        return true;
      }
    });
    return isInvalid;
  }

  isNan(value: number): boolean {
    return Number(value) == NaN;
  }

  async getTeamMembers() {
    // let res: any;
    //   console.log(this.slotSelected);

    //   this.httpService.putRequest({
    //     customApiUrl: this.BASE_URL.TEAM_MEMBERS,
    //     date: '21-08-2020',
    //     slot:  this.slotSelected,
    //     data: { slug: this.slug }

    //   }).subscribe((data: any) => {

    //   if (data.code === 200) {
    //     this.managerList = data.data.map(v => {
    //       if (v.hasOwnProperty("owner_id")) {
    //         return {
    //           manager_id: v.owner_id,
    //           manager_first_name: v.owner_first_name,
    //           manager_last_name: v.owner_last_name
    //         }
    //       }
    //       return v;
    //     })
    //   }
    // })
    this.httpService
      .postRequest({
        customApiUrl: this.BASE_URL.TEAM_MEMBERS,
        data: { slug: this.slug },
        date: this.selectedDate,
        slot_time: this.slotSelected,
        product: "APPOINTMENTS",
      })
      .subscribe(
        (data: any) => {
          if (data.code === 200) {
            // this.managerList = data.data.filter(v => {
            //   return v.role == 'Manager'
            // })
            this.managerList = data.data.map((v) => {
              if (v.hasOwnProperty("owner_id")) {
                return {
                  manager_id: v.owner_id,
                  manager_first_name: v.owner_first_name,
                  manager_last_name: v.owner_last_name,
                };
              }
              return v;
            });
          }
        },
        (error) => {
          // if (error.status === 406) {
          //   this.toastrService.error("No Slots Available");
          // }
        }
      );
  }

  emptyContent(flexField) {
    this.CategorySelected = "";
    flexField.forEach((field) => {
      field.content = "";
    });
  }

  onSubmitAppointment(form: NgForm) {
    this.addAppSubmitClicked = true;
    // console.log("form", form);
    if (this.isFlexInvalid(this.addAppointmentFlexFieldList)) {
      return;
    }
    if (this.addAppointmentFlexFieldList.length !== 0) {
      var appointmentFields = this.addAppointmentFlexFieldList
        .map((field) => {
          if (field.content == null) {
            field.content = "";
          }
          if (
            field.content !== "" &&
            field.content !== null &&
            field.input_type == "Number"
          ) {
            field.content = field.content.toString();
          }
          return {
            [field.field_id]:
              field.input_type == "Toggle"
                ? field.content.toString()
                : field.content,
          };
        })
        .reduce((object, commaSeparated) => {
          return { ...object, ...commaSeparated };
        });
    }
    // if((this.tag_team_member_setting == 'Both' || this.tag_team_member_setting == 'Consumer') && this.teamMemberSelected== ''){
    if (
      !this.autoAssignTeamMember &&
      (this.tag_team_member_setting == "Both" ||
        this.tag_team_member_setting == "Consumer") &&
      this.teamMemberSelected == ""
    ) {
      this.toastrService.error("Please Select a Team Member");
      return;
    }
    if (
      form.valid &&
      this.appointment_cust_name != "" &&
      this.appointment_phone_number != ""
    ) {
      const sourceFromStorage = sessionStorage.getItem("source");
      this.disabled_till_response = true;
      console.log(sourceFromStorage);
      this.httpService
        .postRequest({
          customApiUrl: this.BASE_URL.BOOK_APPOINTMENT,
          data: {
            first_name: this.appointment_cust_name,
            last_name: null,
            phone_number: this.appointment_phone_number,
            email_id: this.emailID || "",
            country_code: 91,
            notes: this.appointment_notes,
            slug: this.slug,
            date: this.selectedDate,
            slot_time: this.slotSelected,
            is_option: this.optionForWhatsApp,
            ...(this.CategorySelected !== "" && {
              category_id: this.CategorySelected,
            }),
            fields: appointmentFields,
            ...(sourceFromStorage !== null && {
              source: JSON.parse(sourceFromStorage),
            }),
            tag_team_member: this.teamMemberSelected || null,
            meeting_link: this.enableMeetingLink,
          },
        })
        .subscribe(
          (data: any) => {
            console.log(this.showSuccessScreen);

            if (data.code === 200) {
              this.disabled_till_response = false;
              this.toastrService.success(data.data.message);
              this.appointment_id = data.data.appointment_id;
              this.addAppSubmitClicked = false;
              this.showSuccessScreen = true;
              this.getAppointmentDetail();
              this.ref.markForCheck();
              // this.CategorySelected = '';
              // this.emptyContent(this.addAppointmentFlexFieldList);
              this.onCloseAppointmentModal();
              this.appointment_cust_name = "";
              this.appointment_phone_number = "";
              this.emailID = ''
            }
          },
          (error) => {
            console.log(error);
            this.CategorySelected = "";
            this.emptyContent(this.addAppointmentFlexFieldList);
            if (error.status === 402 || error.status === 409) {
              this.toastrService.error(error.error.message);
              this.onCloseAppointmentModal();
            }
          }
        );
    }
  }
  teamMemberSelectedChange(val) {
    this.teamMemberSelected = val.manager_id;
    this.teamMemberSelectedName =
      val.manager_first_name + " " + val.manager_last_name;
    console.log(this.teamMemberSelected);
  }
  getAvailableSlot() {
    this.httpService
      .putRequest({
        customApiUrl: this.BASE_URL.AVAILABLE_SLOTS,
        data: { slug: this.slug, date: this.selectedDate },
      })
      .subscribe(
        (data: any) => {
          if (data.code === 200) {
            this.slotsAvailable = data.data.slots.filter(
              (slot) => slot.status === 0
            );
            this.slotSelected =
              this.slotsAvailable.length && this.slotsAvailable[0].hours;
            // console.log("slots available", this.slotsAvailable);
            const dayOfTheWeek = moment(this.selectedDate, "DD-MM-YYYY").format(
              "dddd"
            );
            let holiday = this.public_holiday.some((v) => {
              // console.log(moment(v.date ).format("YYYY-MM-DD"), '===' ,moment(this.selectedDate , "DD-MM-YYYY").format("YYYY-MM-DD") );
              // console.log(moment(v.date ).format("YYYY-MM-DD") == moment(this.selectedDate , "DD-MM-YYYY").format("YYYY-MM-DD") );

              return (
                moment(v.date).format("YYYY-MM-DD") ==
                moment(this.selectedDate, "DD-MM-YYYY").format("YYYY-MM-DD")
              );
            });
            console.log(holiday);

            this.noSlotsAvailablePopupDate = moment(
              this.selectedDate,
              "DD-MM-YYYY"
            ).format("MMMM Do YYYY");
            this.slotsAvailable.length && !holiday
              ? this.modal.open(this.addAppointment, {
                  windowClass: "app-modal-window",
                })
              : this.modal.open(this.noSlotsAvailable, {
                  backdropClass: "light-blue-backdrop",
                });

            this.getTeamMembers();
          }
        },
        (error) => {
          if (error.status === 406) {
            this.toastrService.error("No Slots Available");
          }
        }
      );
  }
  onCloseAppointmentModal() {
    this.optionForWhatsApp = false;
    this.addAppSubmitClicked = false;
    this.appointment_cust_name = "";
    this.appointment_phone_number = "";
    this.emailID = ''
    this.emptyContent(this.addAppointmentFlexFieldList);
    this.modal.dismissAll("addAppointment");
  }
  isBookingAvailable() {
    return moment(this.selectedDate, "DD-MM-YYYY").isBetween(
      moment(this.commonService.getDate(), "DD-MM-YYYY"),
      moment(this.lastBookingDate, "DD-MM-YYYY"),
      "days",
      "[]"
    );
  }
  enable_meeting_link(e) {
    if (e === true) {
      this.enableMeetingLink = true;
    } else {
      this.enableMeetingLink = false;
    }
  }
  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    this.enableMeetingLink = false;
    this.stepOneSubmitClicked = false;
    this.selected_tab_circle = "step_1";
    this.ref.markForCheck();
    this.selectedDate = moment(date).format("DD-MM-YYYY");
    if (!this.isBookingAvailable()) {
      return;
    }
    if (this.is_product_blocked) {
      return;
    }
    if (this.creditsExhausted) {
      this.modal.open(this.creditsExhaustedModal);
      return;
    }
    this.teamMemberSelected = "";
    this.getAvailableSlot();

    // var myDiv = document.getElementById('dayViewContParent');
    // myDiv.scrollIntoView();
    // setTimeout(() => {
    //   this.dayViewScrollBar.directiveRef.scrollToElement('.cal-event');
    // }, 0);
    // this.setViewStartEndTime(moment(date).format('dddd'));
    // this.showAddAppointment = this.isBookingAvailable();
    if (isSameMonth(date, this.viewDate)) {
      this.viewDate = date;
    }
  }

  beforeWeekViewRender(renderEvent: CalendarWeekViewBeforeRenderEvent): void {
    renderEvent.header.forEach((day) => {
      day.isToday =
        moment(day.date).format("DD-MM-YYYY") ==
        moment(this.commonService.onDateFilter()).format("DD-MM-YYYY");
      day.isToday && (day.isPast = false);
    });
  }
  beforeMonthViewRender(renderEvent: CalendarMonthViewBeforeRenderEvent): void {
    renderEvent.body.forEach((day) => {
      day.isToday =
        moment(day.date).format("DD-MM-YYYY") ==
        moment(this.commonService.onDateFilter()).format("DD-MM-YYYY");
      day.isToday && (day.isPast = false);
      const dateOfMonth = day.date;
      let isBetween = moment(dateOfMonth).isBetween(
        moment(this.commonService.getDate()),
        moment(this.lastBookingDate, "DD-MM-YYYY"),
        "days",
        "[]"
      );
      if (!isBetween || this.is_product_blocked) {
        day.cssClass = "bg-cellDisabled";
      }
      // if (moment(dateOfMonth).format("DD-MM-YYYY") === moment(this.viewDate).format("DD-MM-YYYY")) {
      //   day.cssClass = 'bg-zceppa';
      // }
    });
  }
  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay(event, isToday: boolean = false) {
    this.selectedDate = this.commonService.onDateFormat(
      isToday ? new Date() : event,
      "DD-MM-YYYY"
    );
    console.log(this.commonService.getDate());
    isToday && (this.viewDate = this.commonService.getDate());
    console.log(this.selectedDate);
    console.log(this.viewDate);

    // this.showAddAppointment = this.isBookingAvailable();
  }
  show12Hours(time) {
    return moment(time, ["HH.mm A"]).format("hh:mm A");
  }
  checkValidToProceed(postType) {
    this.stepOneSubmitClicked = true;
    if(postType == 'step_1'){
      this.addAppSubmitClicked = false;
    }
    if (this.isFlexInvalid(this.addAppointmentFlexFieldList)) {
      return;
    }
    if (
      !this.autoAssignTeamMember &&
      (this.tag_team_member_setting == "Both" ||
        this.tag_team_member_setting == "Consumer") &&
      this.teamMemberSelected == ""
    ) {
      this.toastrService.error("Please Select a Team Member");
      return;
    }
    this.selected_tab_circle = postType;
  }
}
